import { AiFillAppstore } from "react-icons/ai";
import {  FaBrain} from "react-icons/fa";
import { SiProgress} from "react-icons/si";
import { CgWebsite } from "react-icons/cg";
import { MdAnalytics } from "react-icons/md";


// Features Data
export const featuresData = [
  {
    id: 1,
    title: "Co-Leader",
    subtitle: "Coding Club",
    des: "Work on cool projects while fostering a learning and collaborative environment.",
  },
  {
    id: 2,
    title: "Navigator",
    subtitle: "Rocketry Design Team",
    des: "Contribute to the development of the rocket’s guidance system.",
  },
  {
    id: 3,
    title: "Event Coordinator",
    subtitle: "TMU Engineering Department",
    des: "I organize engineering-related events.",
  }
];



